import styled from 'styled-components';

const SectionHeadTitleBar = styled.div`
  display: flex;
  align-items: center;

  > button {
    width: auto;
    margin-left: ${(props): string => props.theme.spaces.md};

    &:first-of-type {
      margin-left: auto;
    }
  }
`;

export { SectionHeadTitleBar };
